import { render, staticRenderFns } from "./pdca6.vue?vue&type=template&id=554a47cd&scoped=true&"
import script from "./pdca6.vue?vue&type=script&lang=js&"
export * from "./pdca6.vue?vue&type=script&lang=js&"
import style0 from "./pdca6.vue?vue&type=style&index=0&id=554a47cd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554a47cd",
  null
  
)

export default component.exports